import React, { useContext } from 'react';
import * as styles from './index.module.less';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import { CLASS_MAP } from '../..';
import { H4 } from '@/components';
import OffTag from '../off-tag';
import { PricingContext } from '@/modules/pricing-v2/provider';
import { OFF_TAG_CONTENT_MAP } from '@/modules/pricing-v2/constants';

interface ICardHeader {
  title: string;
  desc: string;
  index: number;
  type: GOODS_TYPE;
  className?: string;
}

const CardHeader = ({ title, desc, index, type, className = '' }: ICardHeader) => {
  const { formInfo, lang } = useContext(PricingContext);
  const offText = OFF_TAG_CONTENT_MAP?.[type]?.[lang];

  return (
    <div
      style={{
        gridArea: `h${index}`,
      }}
      className={`${styles.card_header} ${styles[CLASS_MAP[type]]} ${styles[lang]} ${className}`}
    >
      <H4 as="div" className={styles.card_title}>
        <div className={styles.title_text}>{title}</div>
        {lang === 'ja' && formInfo.payType === 'year' && offText && (
          <OffTag className={styles.off_tag}>{offText}</OffTag>
        )}
      </H4>
      <div className={styles.desc}>{desc}</div>
    </div>
  );
};

export default CardHeader;
